import { userItemFragment } from '@reconcept-platform/shared/data-access';
import { gql } from 'apollo-angular';

export const workspaceUserItemFragment = gql`
  fragment WorkspaceUserItem on User {
    ...UserItem
    isOnboarded
    isAdmin
  }
  ${userItemFragment}
`;
